const planetColor = {
  sun: "D8904D",
  mercury: "A4A4A4",
  venus: "D8CA4D",
  earth: "4D7CD8",
  moon: "A4A4A4",
  mars: "D8664D",
  jupiter: "D8B14D",
  saturn: "F4CD9E",
  uranus: "4DBFD8",
  neptune: "4D5BD8",
  pluto: "9E754F",
};

export default planetColor;
